@if (true) {
  <div class="confirm-main">
    <h2 mat-dialog-title
      class="draggable-dialogue-header"
      cdkDrag
      cdkDragRootElement=".cdk-overlay-pane"
      cdkDragHandle>
      {{Title}}
    </h2>
    <div>
      <p>Use this function to validate street addresses and look up census tract values.</p>
    </div>
    @if (ShowConfiguration) {
      <div style="width: 100%;">
        <b>Geocode Grid Columns</b>
        <br />
        <div class="column-name">Address</div>
        @if (GridHasColumn('Address')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('Address')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">City</div>
        @if (GridHasColumn('city')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('city')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">State</div>
        @if (GridHasColumn('state')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('state')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">ZIP</div>
        @if (GridHasColumn('zip')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('zip')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Longitude</div>
        @if (GridHasColumn('longitude')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('longitude')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Latitude</div>
        @if (GridHasColumn('latitude')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('latitude')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Censustract2010</div>
        @if (GridHasColumn('censustract2010')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('censustract2010')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Censustract2020</div>
        @if (GridHasColumn('censustract2020')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('censustract2020')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Validation</div>
        @if (GridHasColumn('validation')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('validation')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Matchtype</div>
        @if (GridHasColumn('matchtype')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('matchtype')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Validatedaddress</div>
        @if (GridHasColumn('validatedaddress')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('validatedaddress')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Geoid</div>
        @if (GridHasColumn('geoid')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('geoid')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <div class="column-name">Place</div>
        @if (GridHasColumn('place')) {
          <div class="column-found"><mat-icon>check</mat-icon></div>
        }
        @if (!GridHasColumn('place')) {
          <div class="column-found"><mat-icon>cancel</mat-icon></div>
        }
        <br />
      </div>
    }
    <br />
    <div>
      <button type="button" mat-raised-button color="primary" class="theme-primary-btn" (click)="onStart()">Start</button>
      &nbsp;
      <button mat-button (click)="onDismiss()">Cancel</button>
    </div>
  </div>
}
